document.addEventListener("DOMContentLoaded", () => {
  const menuItems = Array.from(document.querySelectorAll(".sidemenu_item"));
  const sections = Array.from(
    document.querySelectorAll(".c_float_menu_section")
  );

  if (menuItems.length === 0 || sections.length === 0) {
    return;
  }

  let currentKey = null;
  let currentRatio = 0;
  const CLICK_SCROLL_IDLE_LOCK_MS = 180;
  let lockedKey = null;
  let lockExpiresAt = 0;

  const setActive = (sectionKey, ratio = 0) => {
    menuItems.forEach((item) => {
      const target =
        item.dataset.targetSection ||
        item.getAttribute("href")?.replace("#", "");
      item.classList.toggle("-active", target === sectionKey);
    });
    currentKey = sectionKey;
    currentRatio = ratio;
  };

  const resolveSectionKey = (section) =>
    section.dataset.section || section.getAttribute("id");

  const getLastSectionKey = () => {
    const lastSection = sections[sections.length - 1];
    return lastSection ? resolveSectionKey(lastSection) : null;
  };

  const lockScrollSwitch = (sectionKey) => {
    lockedKey = sectionKey;
    lockExpiresAt = performance.now() + CLICK_SCROLL_IDLE_LOCK_MS;
  };

  const refreshScrollLock = () => {
    if (lockedKey) {
      lockExpiresAt = performance.now() + CLICK_SCROLL_IDLE_LOCK_MS;
    }
  };

  const unlockScrollSwitch = () => {
    lockedKey = null;
    lockExpiresAt = 0;
  };

  const isScrollSwitchLocked = () =>
    Boolean(lockedKey) && performance.now() < lockExpiresAt;

  const isAtPageBottom = () =>
    window.scrollY + window.innerHeight >=
    document.documentElement.scrollHeight - 2;

  const initialActive = menuItems.find((item) =>
    item.classList.contains("-active")
  );
  if (initialActive) {
    const initialKey =
      initialActive.dataset.targetSection ||
      initialActive.getAttribute("href")?.replace("#", "");
    if (initialKey) {
      currentKey = initialKey;
    }
  }

  if ("IntersectionObserver" in window) {
    const ratioMap = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const key = resolveSectionKey(entry.target);
          if (key) {
            ratioMap.set(
              key,
              entry.isIntersecting ? entry.intersectionRatio : 0
            );
          }
        });

        if (isAtPageBottom()) {
          const lastKey = getLastSectionKey();
          if (lastKey && lastKey !== currentKey) {
            setActive(lastKey, 1);
          }
          unlockScrollSwitch();
          return;
        }

        if (isScrollSwitchLocked()) {
          if (lockedKey && lockedKey !== currentKey) {
            setActive(lockedKey, 1);
          }
          return;
        }

        if (lockedKey) {
          unlockScrollSwitch();
          return;
        }

        let bestKey = null;
        let bestRatio = 0;
        ratioMap.forEach((ratio, key) => {
          if (ratio > bestRatio) {
            bestRatio = ratio;
            bestKey = key;
          }
        });

        const currentVisibleRatio = ratioMap.get(currentKey) || 0;
        const shouldSwitch =
          !currentKey ||
          currentVisibleRatio === 0 ||
          (bestKey &&
            bestKey !== currentKey &&
            bestRatio >= currentRatio + 0.15);

        if (bestKey && shouldSwitch) {
          setActive(bestKey, bestRatio);
        }
      },
      {
        root: null,
        rootMargin: "-20% 0px -20% 0px",
        threshold: [0, 0.25, 0.5, 1],
      }
    );

    sections.forEach((section) => {
      const key = resolveSectionKey(section);
      if (key) {
        ratioMap.set(key, 0);
      }
      observer.observe(section);
    });
  } else {
    const onScroll = () => {
      if (isAtPageBottom()) {
        const lastKey = getLastSectionKey();
        if (lastKey && lastKey !== currentKey) {
          setActive(lastKey, 1);
        }
        unlockScrollSwitch();
        return;
      }

      if (isScrollSwitchLocked()) {
        if (lockedKey && lockedKey !== currentKey) {
          setActive(lockedKey, 1);
        }
        return;
      }

      if (lockedKey) {
        unlockScrollSwitch();
        return;
      }

      let nextKey = null;
      let minOffset = Number.POSITIVE_INFINITY;

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const offset = Math.abs(rect.top);
        if (rect.top <= window.innerHeight * 0.4 && offset < minOffset) {
          minOffset = offset;
          nextKey = resolveSectionKey(section);
        }
      });

      if (nextKey && nextKey !== currentKey) {
        setActive(nextKey);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  }

  const releaseLockByUserIntent = () => {
    if (lockedKey) {
      unlockScrollSwitch();
    }
  };

  window.addEventListener("scroll", refreshScrollLock, { passive: true });
  window.addEventListener("wheel", releaseLockByUserIntent, { passive: true });
  window.addEventListener("touchmove", releaseLockByUserIntent, {
    passive: true,
  });
  window.addEventListener("keydown", (event) => {
    if (
      event.key === "PageDown" ||
      event.key === "PageUp" ||
      event.key === "Home" ||
      event.key === "End" ||
      event.key === "ArrowDown" ||
      event.key === "ArrowUp" ||
      event.key === " " ||
      event.key === "Spacebar"
    ) {
      releaseLockByUserIntent();
    }
  });
  window.addEventListener("scrollend", unlockScrollSwitch);

  menuItems.forEach((item) => {
    item.addEventListener("click", () => {
      const target =
        item.dataset.targetSection ||
        item.getAttribute("href")?.replace("#", "");
      if (target) {
        lockScrollSwitch(target);
        setActive(target);
      }
    });
  });
});
